/* Nibby: ingredient cards open a native <dialog>; mobile row scrolls with arrows. */
if (!customElements.get('nibby-ingredients')) {
  customElements.define(
    'nibby-ingredients',
    class NibbyIngredients extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-ingredients-list]');
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-ingredient-open]');
          if (opener) {
            const dialog = this.querySelector(`#${opener.dataset.ingredientOpen}`);
            if (dialog && typeof dialog.showModal === 'function') {
              dialog.showModal();
              document.body.classList.add('nibby-dialog-open');
            }
            return;
          }
          if (event.target.closest('[data-ingredient-close]')) {
            event.target.closest('dialog').close();
            return;
          }
          // Click on the backdrop (outside the inner panel) closes the dialog.
          if (event.target.tagName === 'DIALOG') event.target.close();
          if (event.target.closest('[data-ingredients-prev]')) this.scroll(-1);
          if (event.target.closest('[data-ingredients-next]')) this.scroll(1);
        });
        this.querySelectorAll('dialog').forEach((dialog) =>
          dialog.addEventListener('close', () => document.body.classList.remove('nibby-dialog-open'))
        );
      }

      scroll(direction) {
        if (!this.list) return;
        const item = this.list.querySelector('.nibby-ingredients__item');
        const step = item ? item.getBoundingClientRect().width + 16 : this.list.clientWidth * 0.8;
        this.list.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    }
  );
}
